// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0fb70b4a","340":"e1078363","404":"0d16d1ad"}[chunkId] + ".chunk.js";
};